
    import "src/feature/events/components/text-section/styles.module.css?farm_css_modules";
    
    export default {"quillWrapper": `quillWrapper-f3a3394c`}
    